import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['card', 'cities', 'citiesWrap'];

  connect() {
    this._onResize = () => this.updateCitiesScroll();
    window.addEventListener('resize', this._onResize);
    // Layout may not be final on connect
    requestAnimationFrame(() => this.updateCitiesScroll());
  }

  disconnect() {
    window.removeEventListener('resize', this._onResize);
  }

  filter(event) {
    const city = event.params.city;
    const button = event.currentTarget;
    this.element.querySelectorAll('.studio-browser__city').forEach((el) => {
      el.classList.toggle('is-active', el === button);
    });

    this.cardTargets.forEach((card) => {
      const match = city === 'all' || card.dataset.city === city;
      card.classList.toggle('is-hidden', !match);
    });

    // Prototype: center active chip in the horizontal scroll row on narrow screens
    if (window.innerWidth <= 860 && this.hasCitiesTarget && button) {
      const row = this.citiesTarget;
      row.scrollTo({
        left: button.offsetLeft - (row.clientWidth - button.offsetWidth) / 2,
        behavior: 'smooth'
      });
      // Update fades after smooth scroll settles a bit
      setTimeout(() => this.updateCitiesScroll(), 320);
    }
  }

  updateCitiesScroll() {
    if (!this.hasCitiesTarget || !this.hasCitiesWrapTarget) return;

    const row = this.citiesTarget;
    const wrap = this.citiesWrapTarget;
    const maxScroll = row.scrollWidth - row.clientWidth;
    const canScroll = maxScroll > 2;

    wrap.classList.toggle('is-scrollable', canScroll);
    wrap.classList.toggle('is-scrollable-start', canScroll && row.scrollLeft > 2);
    wrap.classList.toggle('is-scrollable-end', canScroll && row.scrollLeft < maxScroll - 2);
  }
}
